import { GeoJSONFeature } from "mapbox-gl";
import { SearchResultProps } from "@/utils/types";

const SEARCH_MAPBOX_GEOCODE_URL = "https://api.mapbox.com/search/geocode/v6/forward";
const SEARCH_MAPBOX_GEOCODE_COUNTY = "us";
const SEARCH_MAPBOX_GEOCODE_TYPES = ["region", "postcode", "place", "locality", "neighborhood", "street", "address"];

export const getSearchResults = async (query: string, signal: AbortSignal) => {
	const mapboxGeocodeParams = new URLSearchParams({
		q: query,
		access_token: process.env.NEXT_PUBLIC_MAPBOX_TOKEN_SEARCH || "",
		country: SEARCH_MAPBOX_GEOCODE_COUNTY,
		types: SEARCH_MAPBOX_GEOCODE_TYPES.join(",")
	});
	const mapboxGeocodeUrl = `${SEARCH_MAPBOX_GEOCODE_URL}?${mapboxGeocodeParams.toString()}`;
	const mapboxGeocodeRes =
		await fetch(mapboxGeocodeUrl, {
			signal,
			method: "GET",
			headers: {
				"Cache-Control": "no-store"
			}
		})
		.then(response => {
			if (!response.ok) {
				throw new Error(`Fetch to ${mapboxGeocodeUrl} failed`);
			}
			return response.json();
		})
		.catch(error => {
			if (error.name === "AbortError") {
				console.log("Fetch aborted");
			} else {
				console.error("Fetch error", error);
			}
		});
	// Returns a `FeatureCollection` with queried results in `features`
	const mapboxFeatures = mapboxGeocodeRes?.features;
	const searchResults: SearchResultProps[] = mapboxFeatures?.map(getResultProps);
	return searchResults;
}

const getResultProps = (feature: GeoJSONFeature) => {
	return {
		name: getResultName(feature),
		bbox: getResultBbox(feature),
		coordinates: getResultCoordinates(feature),
		type: getResultType(feature),
	}
}

const getResultName = (feature: GeoJSONFeature) => {
	let resultName;
	if(feature?.properties?.feature_type === "place") {
		resultName = feature?.properties?.full_address.replace(", United States", "");
	} else if(feature?.properties?.feature_type === "locality") {
		resultName = feature?.properties?.full_address.replace(", United States", "");
	} else if(feature?.properties?.feature_type === "neighborhood") {
		resultName = feature?.properties?.full_address.replace(", United States", "");
	} else if(feature?.properties?.feature_type === "street") {
		resultName = feature?.properties?.full_address.replace(", United States", "");
	} else if(feature?.properties?.feature_type === "address") {
		resultName = feature?.properties?.full_address.replace(", United States", "");
	} else if(feature?.properties?.feature_type === "postcode") {
		resultName = feature?.properties?.name_preferred;
	} else {
		resultName = feature?.properties?.full_address;
	}
	return resultName;
}

const getResultBbox = (feature: GeoJSONFeature) => {
	return feature?.properties?.bbox;
}

const getResultCoordinates = (feature: GeoJSONFeature) => {
	return feature?.properties?.coordinates;
}

const getResultType = (feature: GeoJSONFeature) => {
	return feature?.properties?.feature_type;
}